export function interviewToFormData(agencyInterview, agentInterview) {
    const agencyAnswer = questionType => agencyInterview?.questionAnswers?.[questionType]?.answer;
    const agentAnswer = questionType => agentInterview?.questionAnswers?.[questionType]?.answer;

    const middleName = agentAnswer("MiddleName")?.length > 0 ? ` ${agentAnswer("MiddleName")} ` : " ";
    const suffix = agentAnswer("Suffix")?.length > 0 ? ` ${agentAnswer("Suffix")}` : "";

    const defaultPayeeName = agencyAnswer("W9FeinOrSsn") == "fein" ?
        agencyAnswer("AgencyName") :
        `${agentAnswer("FirstName")}${middleName}${agentAnswer("LastName")}${suffix}`;

    return {
        fein: agencyAnswer("Fein"),
        ssn: agencyAnswer("Ssn"),
        payeeName: agencyAnswer("PayeeName") ?? defaultPayeeName,
        accountType: agencyAnswer("AccountType"),
        routingNumber: agencyAnswer("RoutingNumber"),
        accountNumber: agencyAnswer("AccountNumber"),
        reenterAccountNumber: agencyAnswer("AccountNumber"),
        bankName: agencyAnswer("BankName")
    };
}

export function formDataToQuestionAnswers(formData) {
    const mapIfExists = (key, value) => value !== null && value !== undefined ? { [key]: { answer: value } } : {};

    return {
        ...mapIfExists("Fein", formData.fein),
        ...mapIfExists("Ssn", formData.ssn),
        ...mapIfExists("PayeeName", formData.payeeName),
        ...mapIfExists("AccountType", formData.accountType),
        ...mapIfExists("RoutingNumber", formData.routingNumber),
        ...mapIfExists("AccountNumber", formData.accountNumber),
        ...mapIfExists("BankName", formData.bankName)
    };
}
